import React from 'react';
import { Tooltip } from '@material-ui/core';
import { Redo } from '@material-ui/icons';

const ResendIcon = ({
	value,
	onClick = () => false,
	tooltip = 'Reenviar',
	disabled,
	color = 'primary',
	className = '',
}) => {
	return (
		<Tooltip title={tooltip}>
			<span>
				<button
					onClick={onClick}
					disabled={disabled}
					style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
					className={`btn btn-icon btn-sm btn-${
						disabled ? 'light' : color
					} ${className}`}
				>
					<span className={`svg-icon svg-icon-md`}>
						<Redo />
					</span>
				</button>
			</span>
		</Tooltip>
	);
};

export default ResendIcon;
